<template>
    <div>
        <v-dialog v-model="dialog" persistent max-width="450">
            <v-card>
                <!-- <v-card-title><span class="headline">電気図面依頼</span></v-card-title> -->
                <v-card-title><span class="headline">電気図面依頼（提案電気図面依頼含む）</span></v-card-title>
                <v-container>
                    <v-card-text class="pt-0">
                        <v-container>
                            <v-row no-gutters>
                                <!-- DENKI GRAVITY -->
                                <!-- :disabled="OPTION_11 != null" -->
                                <v-radio-group v-model="radioElectrical" column hide-details>
                                    <v-radio label="提案電気図面依頼" value="提案電気図面依頼" class="ml-n4 mb-0" @click="clearOption11()"></v-radio>
                                        <v-col cols="12"><div style="font-size:12px;color:red;" class="ml-1 mt-0">原則間取り確定後１回だけ依頼可能</div></v-col>
                                </v-radio-group>
                                <v-radio-group  v-model="radioPdr" column hide-details style="margin: 0 auto" v-if="radioElectrical != null">
                                    <!-- <v-radio label="提案電気図面依頼" value="5" class="ml-n5 mb-0"></v-radio>
                                        <v-col cols="12"><div style="font-size:12px;color:red;" class="ml-1 mt-0">原則間取り確定後１回だけ依頼可能</div></v-col> -->
                                    <v-radio
                                        label="標準プラン"
                                        value="1"
                                        class="ml-2">
                                    </v-radio>
                                    <v-radio
                                        label="提案プラン"
                                        value="2"
                                        class="ml-2">
                                    </v-radio>
                                    <v-radio
                                        label="ＣＡＤ図面（配線位置を記入したもの）添付あり"
                                        value="3"
                                        class="ml-2">
                                    </v-radio>
                                    <!-- <v-radio
                                        label="なし"
                                        value="なし"
                                        class="ml-2">
                                    </v-radio> -->
                                </v-radio-group>

                                <!-- OPTION_1 -->
                                <!-- <v-col cols="12"><span style="font-size:16px;font-family:Arial, Helvetica, sans-serif;">電気図面依頼</span></v-col> -->
                                <!-- :disabled="radioElectrical != null" -->
                                <v-col cols="12" class="mt-n2">
                                    <v-row no-gutters>
                                        <v-radio-group hide-details row v-model="OPTION_11">
                                            <v-radio label="電気図面依頼" value="電気図面依頼" class="ml-n4" @click="clearRadioElec()"></v-radio>
                                        </v-radio-group>
                                    </v-row>
                                    <v-row no-gutters class="mt-0">
                                        <v-radio-group hide-details row v-model="OPTION_1" v-if="OPTION_11 != null">
                                            <v-radio label="あり" value="あり" class="ml-3"></v-radio>
                                            <v-radio label="なし" value="なし" class="ml-3"></v-radio>
                                        </v-radio-group>
                                    </v-row>
                                </v-col>

                                <!-- OPTION_2 -->
                                <!-- <v-col cols="12" class="mt-3"><span style="font-size:16px;font-family:Arial, Helvetica, sans-serif;">E更新</span></v-col> -->
                                <v-col cols="12" class="mt-4 ml-n3"><span style="font-size:16px;font-family:Arial, Helvetica, sans-serif;" v-if="OPTION_11 != null && OPTION_1 == 'あり'">電気図面自動更新（E更新）</span></v-col>
                                    <div style="font-size:12px;color:red;" class="ml-4 mt-0" v-if="OPTION_11 != null && OPTION_1 == 'あり'">あり：CAD修正図面を元にHRDにて自動作成</div>
                                    <div style="font-size:12px;color:red;" class="ml-4 mt-0" v-if="OPTION_11 != null && OPTION_1 == 'あり'">なし：電気図面修正依頼を添付あり</div>
                                <v-col cols="12" v-if="OPTION_11 != null && OPTION_1 == 'あり'">
                                    <v-radio-group  hide-details row v-model="OPTION_2" :disabled="isOption2Disabled">
                                        <v-radio label="あり" value="あり" class="ml-3"></v-radio>
                                        <v-radio label="なし" value="なし" class="ml-3"></v-radio>
                                    </v-radio-group>
                                </v-col>

                                <!-- DENKI PLAN GRAVITY -->
                                <v-col cols="12" class="mt-3 ml-n3"
                                    v-show="(OPTION_1 == 'あり' && OPTION_2 == 'なし') || (OPTION_1 == 'あり' && OPTION_2 == null)">
                                        <span style="font-size:16px;font-family:Arial, Helvetica, sans-serif;" v-if="OPTION_11 != null && OPTION_1 == 'あり'">修正箇所数：</span>
                                </v-col>
                                    <v-radio-group 
                                        v-show="(OPTION_1 == 'あり' && OPTION_2 == 'なし') || (OPTION_1 == 'あり' && OPTION_2 == null)"
                                        v-if="OPTION_11 != null && OPTION_1 == 'あり'"
                                        v-model="radioGravity"
                                        hide-details 
                                        column 
                                        class="ml-1">

                                        <v-radio
                                            label="約1～10ヵ所の変更 (軽微な変更)" 
                                            value="軽微な変更 (S)"
                                            class="ml-3">
                                        </v-radio>
                                        <v-radio 
                                            label="約11～50ヵ所の変更 (通常の変更)" 
                                            value="通常の変更 (M)"
                                            class="ml-3">
                                        </v-radio>
                                        <v-radio 
                                            label="約51ヵ所以上の変更 (大きな変更)" 
                                            value="大きな変更 (L)"
                                            class="ml-3">
                                        </v-radio>
                                        <!-- <v-radio 
                                            label="なし" 
                                            value="なし">
                                        </v-radio> -->
                                    </v-radio-group>

                                    <!-- ELECTRICAL DRAWING CHECKBOX / ELECTRICAL REQUEST GRAVITY -->
                                    <v-col cols="12" class="mt-5 ml-n3" v-if="OPTION_11 != null && OPTION_1 == 'あり'"><span style="font-size:16px;font-family:Arial, Helvetica, sans-serif;">電気図面追加依頼：</span></v-col>
                                        <v-col cols="12" v-if="OPTION_11 != null && OPTION_1 == 'あり'">
                                            <v-checkbox
                                                v-model="selectedDrawing"
                                                label="LED 標準数更新"
                                                value="1"
                                                hide-details
                                                class="ml-4"
                                                :disabled="isCheckboxdisabled">
                                            </v-checkbox>
                                        </v-col>
                                        <v-col cols="12" v-if="OPTION_11 != null && OPTION_1 == 'あり'">
                                            <v-checkbox
                                                v-model="selectedDrawing"
                                                label="チェック"
                                                value="2"
                                                hide-details
                                                class="ml-4"
                                                :disabled="isCheckboxdisabled">
                                            </v-checkbox>
                                        </v-col>
                                        <!-- <v-col cols="12" v-if="OPTION_11 != null && OPTION_1 == 'あり'">
                                            <v-checkbox
                                                v-show="$store.state.denkiHousetype != 3 || $store.state.denkiHousetype == 29"
                                                v-model="selectedDrawing"
                                                label="盤図"
                                                value="3"
                                                hide-details
                                                class="ml-4"
                                                :disabled="isCheckboxdisabled">
                                            </v-checkbox>
                                        </v-col> -->
                            </v-row>
                        </v-container>
                    </v-card-text>
                </v-container>
                <v-card-actions>
                    <v-spacer></v-spacer>
                        <v-btn dark color="red" @click="closetoggleDialogElectricalDrawing()">キャンセル</v-btn>
                        <v-btn dark color="green" v-if="OPTION_1 == 'あり' && OPTION_2 != null && radioGravity != null" @click="confirmElectricalDrawing()">保存</v-btn>
                        <v-btn dark color="green" v-else-if="OPTION_1 == 'なし'" @click="confirmElectricalDrawing()">保存</v-btn>
                        <v-btn dark color="green" v-else-if="radioPdr != null" @click="confirmElectricalDrawing()">保存</v-btn>
                        <!-- <v-btn dark color="green" :disabled="OPTION_1 == null || OPTION_1 == 'あり' && OPTION_2 == null && radioGravity == null" @click="confirmElectricalDrawing()">保存</v-btn> -->
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
    props: {
        dialog: Boolean
    },

    data(){
        return {
            radioElectrical : null,
            OPTION_11 : null,
            OPTION_1: null,
            OPTION_2: null,
            isOption2Disabled: true,
            radioGravity: null,
            isCheckboxdisabled : true,
            selectedDrawing : [],
            radioPdr : null,
            selectedValue: null,

        }
    },
    computed : {
        ...mapState([
            'electrical_request',
            'editMode',
            'cadRequestRevisionContent',
            'editCadRequestRevisionContent',
        ]),
    },

    methods: {
        clearOption11(){
            this.OPTION_11 = null;
            this.OPTION_1 = null;
            this.OPTION_2 = null;
            this.radioGravity = null;
            this.selectedDrawing = [];
        },

        clearRadioElec(){
            this.radioElectrical = null;
            this.radioPdr = null;
        },

        closetoggleDialogElectricalDrawing(){
            if(!this.editMode) {
                this.radioElectrical = null;
                this.OPTION_11 = null;
                this.OPTION_1 = null;
                this.OPTION_2 = null;
                this.radioGravity = null;
                this.selectedDrawing = [];
                this.radioPdr = null;
                this.$emit('closetoggleDialogElectricalDrawing', null)
                this.toggleDialogElectricalDrawing(false);
            } else {
                this.toggleDialogElectricalDrawing(false);
                // this.$store.state.editCadRequestRevisionContent.shio_request = false;
                // this.$store.state.editCadRequestRevisionContent.SRS_request.shio_selection = null;
            }
        },
        toggleDialogElectricalDrawing(value){
            this.$emit('toggleDialogElectricalDrawing', value);
        },


        confirmElectricalDrawing(){
            this.$emit('confirmElectricalDrawing', {
                radioPdr : this.radioPdr,
                OPTION_1: this.OPTION_1,
                OPTION_2: this.OPTION_2,
                radioGravity : this.radioGravity,
                selectedDrawing : this.selectedDrawing ? this.selectedDrawing : [],
                pdr_title :this.radioElectrical,
                denki_plan_title :this.OPTION_11
            });
            this.toggleDialogElectricalDrawing(false);

        // if(this.$store.state.getCadNashi) {
        //     this.$store.state.cadRequestRevisionContent.shio_request = null;
        // }

        }


    },

    watch: {
        '$store.state.cadRequestRevisionContent'(val){

        },

        '$store.state.editCadRequestRevisionContent'(val){

        },

        '$store.state.electrical_request'(val){
            // console.log(val, 'valvalval')
                // let selectedDrawingArray = val.selectedDrawing.split(", ");
            if(val.selectedDrawing !== null && val.selectedDrawing !== undefined){
                if (Array.isArray(val.selectedDrawing)) {
                    this.selectedDrawing = val.selectedDrawing;
                } else if (typeof val.selectedDrawing === 'string') {
                    this.selectedDrawing = val.selectedDrawing.split(", ");
                }
            } else {
                this.selectedDrawing = [];
            }
            this.radioElectrical = val.pdr_title;
            this.radioPdr = val.radioPdr;
            this.OPTION_11 = val.denki_plan_title;
            this.OPTION_1 = val.OPTION_1;
            this.OPTION_2 = val.OPTION_2;
            this.radioGravity = val.radioGravity;
        },
        OPTION_1(val){
            if(val == 'なし'){
                console.log('option 1 ari')
                console.log('Log: ', this.$store.state.cadRequestRevisionContent.SRS_request.shio_selection)
                
                this.OPTION_2 = null;
                this.radioGravity = null;
                this.selectedDrawing = [];
                this.isOption2Disabled = true;
                this.isCheckboxdisabled = true;

                // NOTE - OLD CONDITION 
                // if(!this.editMode){
                //     this.$store.state.cadRequestRevisionContent.shio_request = true;
                // } else {
                //     this.$store.state.editCadRequestRevisionContent.shio_request = true;
                // }

                // NOTE - NEW CONDITION MODIFIED DEC162025 - UARY
                if(!this.editMode){
                    // if(!this.$store.state.hokkaidou.includes(this.$store.state.cadRequestBasicInformation.house_type_id)){
                    
                    // NOTE - CODED 20260623 
                    // if(!this.$store.state.hokkaidou.some(h => h.id === this.$store.state.cadRequestBasicInformation.house_type_id && (h.hokkaidou == '2' || h.hokkaidou == '1'))){
                    
                    // NOTE - CODED - 20260624 - BY UARY
                   if(this.$store.state.loggedInUser.isHokkaidou_planner != 1 && this.$store.state.hokkaidou.some(h => h.id === this.$store.state.cadRequestBasicInformation.house_type_id && (h.hokkaidou != '2'))){
                       // this.$store.state.cadRequestRevisionContent.SRS_request.shio_selection = '0';
                       // NOTE - MODIFIED BY JARED
                        if (!(this.$store.state.loggedInUser.can_use_srs == 1 && (this.$store.state.cadRequestBasicInformation.house_type_id == 35 || this.$store.state.cadRequestBasicInformation.house_type_id == 36 || this.$store.state.cadRequestBasicInformation.house_type_id == 38 || this.$store.state.cadRequestBasicInformation.house_type_id == 39))) {
                            this.$store.state.editCadRequestRevisionContent.shio_request = true;
                            this.$store.state.cadRequestRevisionContent.SRS_request.shio_selection = '0';
                        } 
                    } else if (this.$store.state.loggedInUser.isHokkaidou_planner == 1 && !this.$store.state.hokkaidou.some(h => h.id === this.$store.state.cadRequestBasicInformation.house_type_id && (h.hokkaidou == '2' || h.hokkaidou == '1'))){
                        this.$store.state.cadRequestRevisionContent.shio_request = true;
                        this.$store.state.cadRequestRevisionContent.SRS_request.shio_selection = '0';
                    }

                    else if(this.$store.state.hokkaidou.some(h => h.id === this.$store.state.cadRequestBasicInformation.house_type_id && (h.hokkaidou == '1') && this.$store.state.loggedInUser.isHokkaidou_planner == 1) && this.$store.state.cadRequestRevisionContent.SRS_request.shio_selection == '0'){
                        // this.$store.state.cadRequestRevisionContent.shio_request = true;
                        this.$store.state.cadRequestRevisionContent.SRS_request.shio_selection = '0';
                    }

                    // else if(this.$store.state.hokkaidou.includes(this.$store.state.cadRequestBasicInformation.house_type_id)){
                    else if(this.$store.state.hokkaidou.some(h => h.id === this.$store.state.cadRequestBasicInformation.house_type_id && (h.hokkaidou == '2' || h.hokkaidou == '1') && this.$store.state.loggedInUser.isHokkaidou_planner == 1) && this.$store.state.cadRequestRevisionContent.SRS_request.shio_selection == '1'){
                        // this.$store.state.cadRequestRevisionContent.shio_request = true;
                        this.$store.state.cadRequestRevisionContent.SRS_request.shio_selection = '1';
                    }

                    else if(this.$store.state.hokkaidou.some(h => h.id === this.$store.state.cadRequestBasicInformation.house_type_id && (h.hokkaidou == '2' || h.hokkaidou == '1') && this.$store.state.loggedInUser.isHokkaidou_planner == 1) && this.$store.state.cadRequestRevisionContent.SRS_request.shio_selection == '3'){
                        this.$store.state.cadRequestRevisionContent.SRS_request.shio_selection = '3';
                    }
                } else {
                    // if(!this.$store.state.hokkaidou.includes(this.$store.state.cadRequestBasicInformation.house_type_id)){
                   
                    // NOTE - CODED 20260623
                    // if(!this.$store.state.hokkaidou.some(h => h.id === this.$store.state.cadRequestBasicInformation.house_type_id && (h.hokkaidou == '2' || h.hokkaidou == '1'))){
                    
                    // NOTE - CODED - 20260624 - BY UARY
                    if(this.$store.state.loggedInUser.isHokkaidou_planner != 1 && this.$store.state.hokkaidou.some(h => h.id === this.$store.state.cadRequestBasicInformation.house_type_id && (h.hokkaidou != '2'))){
                        // this.$store.state.editCadRequestRevisionContent.SRS_request.shio_selection = '0';
                        // this.$store.state.editCadRequestRevisionContent.shio_request = true;

                        if (!(this.$store.state.loggedInUser.can_use_srs == 1 && (this.$store.state.cadRequestBasicInformation.house_type_id == 35 || this.$store.state.cadRequestBasicInformation.house_type_id == 36 || this.$store.state.cadRequestBasicInformation.house_type_id == 38 || this.$store.state.cadRequestBasicInformation.house_type_id == 39))) {
                            this.$store.state.editCadRequestRevisionContent.shio_request = true;
                            this.$store.state.editCadRequestRevisionContent.SRS_request.shio_selection = '0';
                        } 
                     } else if (this.$store.state.loggedInUser.isHokkaidou_planner == 1 && !this.$store.state.hokkaidou.some(h => h.id === this.$store.state.cadRequestBasicInformation.house_type_id && (h.hokkaidou == '2' || h.hokkaidou == '1'))){
                        this.$store.state.editCadRequestRevisionContent.shio_request = true;
                        this.$store.state.editCadRequestRevisionContent.SRS_request.shio_selection = '0';
                        console.log('e');
                    } else if(this.$store.state.hokkaidou.some(h => h.id === this.$store.state.cadRequestBasicInformation.house_type_id && (h.hokkaidou == '1') && this.$store.state.loggedInUser.isHokkaidou_planner == 1) && this.$store.state.editCadRequestRevisionContent.SRS_request.shio_selection == '0'){
                        // this.$store.state.editCadRequestRevisionContent.shio_request = false;
                        this.$store.state.editCadRequestRevisionContent.SRS_request.shio_selection = '0';
                        console.log('f');
                    }

                    // else if(this.$store.state.hokkaidou.includes(this.$store.state.cadRequestBasicInformation.house_type_id)){
                    else if(this.$store.state.hokkaidou.some(h => h.id === this.$store.state.cadRequestBasicInformation.house_type_id && (h.hokkaidou == '2' || h.hokkaidou == '1') && this.$store.state.loggedInUser.isHokkaidou_planner == 1) && this.$store.state.editCadRequestRevisionContent.SRS_request.shio_selection == '1'){
                        // this.$store.state.editCadRequestRevisionContent.shio_request = false;
                        this.$store.state.editCadRequestRevisionContent.SRS_request.shio_selection = '1';
                    }

                    else if(this.$store.state.hokkaidou.some(h => h.id === this.$store.state.cadRequestBasicInformation.house_type_id && (h.hokkaidou == '2' || h.hokkaidou == '1') && this.$store.state.loggedInUser.isHokkaidou_planner == 1) && this.$store.state.editCadRequestRevisionContent.SRS_request.shio_selection == '3'){
                        this.$store.state.editCadRequestRevisionContent.SRS_request.shio_selection = '3';
                    }
                    
                }
            }else if(val == 'あり'){
                console.log('option 1 nashi')
                
                this.isOption2Disabled = false;

                if(this.$store.state.getCadNashi){
                    if(!this.editMode){
                        this.$store.state.cadRequestRevisionContent.shio_request = false;
                    } else {
                        this.$store.state.editCadRequestRevisionContent.shio_request = false;
                    }
                } else {
                    // NOTE - OLD CONDITION 
                    // if(!this.editMode){
                    //     this.$store.state.cadRequestRevisionContent.shio_request = true;
                    // } else {
                    //     this.$store.state.editCadRequestRevisionContent.shio_request = true;
                    // }

                    // NOTE - NEW CONDITION - MODIFIED DEC062025 - UARY
                    if(!this.editMode){
                        // console.log('nagana naman')
                        // if(!this.$store.state.hokkaidou.includes(this.$store.state.cadRequestBasicInformation.house_type_id)){
                        
                        // NOTE - CODED 20260623
                        // if(!this.$store.state.hokkaidou.some(h => h.id === this.$store.state.cadRequestBasicInformation.house_type_id && (h.hokkaidou == '2' || h.hokkaidou == '1'))){
                        
                        // NOTE - CODED - 20260624 - BY UARY
                        if(this.$store.state.loggedInUser.isHokkaidou_planner != 1 && this.$store.state.hokkaidou.some(h => h.id === this.$store.state.cadRequestBasicInformation.house_type_id && (h.hokkaidou != '2'))){
                            // NOTE MODIFIED BY JARED
                            if (!(this.$store.state.loggedInUser.can_use_srs == 1 && (this.$store.state.cadRequestBasicInformation.house_type_id == 35 || this.$store.state.cadRequestBasicInformation.house_type_id == 36 || this.$store.state.cadRequestBasicInformation.house_type_id == 38 || this.$store.state.cadRequestBasicInformation.house_type_id == 39))) {
                                this.$store.state.editCadRequestRevisionContent.shio_request = true;
                                this.$store.state.cadRequestRevisionContent.SRS_request.shio_selection = '0';
                            } 
                            // this.$store.state.cadRequestRevisionContent.SRS_request.shio_selection = '0';
                        } else if (this.$store.state.loggedInUser.isHokkaidou_planner == 1 && !this.$store.state.hokkaidou.some(h => h.id === this.$store.state.cadRequestBasicInformation.house_type_id && (h.hokkaidou == '2' || h.hokkaidou == '1'))){
                            this.$store.state.cadRequestRevisionContent.shio_request = true;
                            this.$store.state.cadRequestRevisionContent.SRS_request.shio_selection = '0';
                        }

                        else if(this.$store.state.hokkaidou.some(h => h.id === this.$store.state.cadRequestBasicInformation.house_type_id && (h.hokkaidou == '1') && this.$store.state.loggedInUser.isHokkaidou_planner == 1) && this.$store.state.cadRequestRevisionContent.SRS_request.shio_selection == '0'){
                            // this.$store.state.cadRequestRevisionContent.shio_request = true;
                            this.$store.state.cadRequestRevisionContent.SRS_request.shio_selection = '0';
                        }

                        // else if(this.$store.state.hokkaidou.includes(this.$store.state.cadRequestBasicInformation.house_type_id)){
                        else if(this.$store.state.hokkaidou.some(h => h.id === this.$store.state.cadRequestBasicInformation.house_type_id && (h.hokkaidou == '2' || h.hokkaidou == '1') && this.$store.state.loggedInUser.isHokkaidou_planner == 1) && this.$store.state.cadRequestRevisionContent.SRS_request.shio_selection == '1'){
                            // this.$store.state.cadRequestRevisionContent.shio_request = true;
                            this.$store.state.cadRequestRevisionContent.SRS_request.shio_selection = '1';
                        }

                        else if(this.$store.state.hokkaidou.some(h => h.id === this.$store.state.cadRequestBasicInformation.house_type_id && (h.hokkaidou == '2' || h.hokkaidou == '1') && this.$store.state.loggedInUser.isHokkaidou_planner == 1) && this.$store.state.cadRequestRevisionContent.SRS_request.shio_selection == '3'){
                            this.$store.state.cadRequestRevisionContent.SRS_request.shio_selection = '3';
                        }
                        
                    } else {
                        // if(!this.$store.state.hokkaidou.includes(this.$store.state.cadRequestBasicInformation.house_type_id)){
                        
                        // NOTE  - CODED 20260623
                        // if(!this.$store.state.hokkaidou.some(h => h.id === this.$store.state.cadRequestBasicInformation.house_type_id && (h.hokkaidou == '2' || h.hokkaidou == '1'))){
                        
                        // NOTE - CODED - 20260624
                        if(this.$store.state.loggedInUser.isHokkaidou_planner != 1 && this.$store.state.hokkaidou.some(h => h.id === this.$store.state.cadRequestBasicInformation.house_type_id && (h.hokkaidou != '2'))){
                            // this.$store.state.editCadRequestRevisionContent.SRS_request.shio_selection = '0';
                            // this.$store.state.editCadRequestRevisionContent.shio_request = true;

                            if (!(this.$store.state.loggedInUser.can_use_srs == 1 && (this.$store.state.cadRequestBasicInformation.house_type_id == 35 || this.$store.state.cadRequestBasicInformation.house_type_id == 36 || this.$store.state.cadRequestBasicInformation.house_type_id == 38 || this.$store.state.cadRequestBasicInformation.house_type_id == 39))) {
                                this.$store.state.editCadRequestRevisionContent.shio_request = true;
                                this.$store.state.editCadRequestRevisionContent.SRS_request.shio_selection = '0';
                            } 
                        }  else if (this.$store.state.loggedInUser.isHokkaidou_planner == 1 && !this.$store.state.hokkaidou.some(h => h.id === this.$store.state.cadRequestBasicInformation.house_type_id && (h.hokkaidou == '2' || h.hokkaidou == '1'))){
                            this.$store.state.editCadRequestRevisionContent.shio_request = true;
                            this.$store.state.editCadRequestRevisionContent.SRS_request.shio_selection = '0';
                        }  else if(this.$store.state.hokkaidou.some(h => h.id === this.$store.state.cadRequestBasicInformation.house_type_id && (h.hokkaidou == '1') && this.$store.state.loggedInUser.isHokkaidou_planner == 1) && this.$store.state.editCadRequestRevisionContent.SRS_request.shio_selection == '0'){
                            // this.$store.state.editCadRequestRevisionContent.shio_request = false;
                            this.$store.state.editCadRequestRevisionContent.SRS_request.shio_selection = '0';
                        }
                        // else if(this.$store.state.hokkaidou.includes(this.$store.state.cadRequestBasicInformation.house_type_id)){
                        else if(this.$store.state.hokkaidou.some(h => h.id === this.$store.state.cadRequestBasicInformation.house_type_id && (h.hokkaidou == '2' || h.hokkaidou == '1') && this.$store.state.loggedInUser.isHokkaidou_planner == 1) && this.$store.state.editCadRequestRevisionContent.SRS_request.shio_selection == '1'){
                            // this.$store.state.editCadRequestRevisionContent.shio_request = false;
                            this.$store.state.editCadRequestRevisionContent.SRS_request.shio_selection = '1';
                        }

                        else if(this.$store.state.hokkaidou.some(h => h.id === this.$store.state.cadRequestBasicInformation.house_type_id && (h.hokkaidou == '2' || h.hokkaidou == '1') && this.$store.state.loggedInUser.isHokkaidou_planner == 1) && this.$store.state.editCadRequestRevisionContent.SRS_request.shio_selection == '3'){
                            this.$store.state.editCadRequestRevisionContent.SRS_request.shio_selection = '3';
                        }
                        
                    }
                }
            }
        },

        OPTION_2(val){
            if(val == 'あり') {
                this.radioGravity = '軽微な変更 (S)';
            } else if( val == 'なし'){
                this.radioGravity = null;
            }
        },

        radioGravity(vaal){
            if(vaal == '軽微な変更 (S)' || vaal == '通常の変更 (M)' || vaal == '大きな変更 (L)'){
                this.isCheckboxdisabled = false;
            }
        },

        radioElectrical(val){
            if(val == '提案電気図面依頼') {
                // NOTE - OLD CONDITION
                // if(!this.editMode){
                //     this.$store.state.cadRequestRevisionContent.shio_request = true;
                //     this.$store.state.cadRequestRevisionContent.SRS_request.shio_selection = '0';
                // } else {
                //     this.$store.state.editCadRequestRevisionContent.shio_request = true;
                //     this.$store.state.editCadRequestRevisionContent.SRS_request.shio_selection = '0';
                // }

                // NOTE - NEW CONDITION - MODIFIED DEC062025 - UARY
                if(!this.editMode){
                    
                    // if(!this.$store.state.hokkaidou.includes(this.$store.state.cadRequestBasicInformation.house_type_id)){
                    
                    // NOTE - CODED 20260623
                    // if(!this.$store.state.hokkaidou.some(h => h.id === this.$store.state.cadRequestBasicInformation.house_type_id && (h.hokkaidou == '2' || h.hokkaidou == '1'))){
                    
                    // NOTE - CODED - 20260624
                    if(this.$store.state.loggedInUser.isHokkaidou_planner != 1 && this.$store.state.hokkaidou.some(h => h.id === this.$store.state.cadRequestBasicInformation.house_type_id && (h.hokkaidou != '2'))){
                        // this.$store.state.cadRequestRevisionContent.SRS_request.shio_selection = '0';
                        if (!(this.$store.state.loggedInUser.can_use_srs == 1 && (this.$store.state.cadRequestBasicInformation.house_type_id == 35 || this.$store.state.cadRequestBasicInformation.house_type_id == 36 || this.$store.state.cadRequestBasicInformation.house_type_id == 38 || this.$store.state.cadRequestBasicInformation.house_type_id == 39))) {
                            this.$store.state.editCadRequestRevisionContent.shio_request = true;
                            this.$store.state.cadRequestRevisionContent.SRS_request.shio_selection = '0';
                        } 
                    } else if (this.$store.state.loggedInUser.isHokkaidou_planner == 1 && !this.$store.state.hokkaidou.some(h => h.id === this.$store.state.cadRequestBasicInformation.house_type_id && (h.hokkaidou == '2' || h.hokkaidou == '1'))){                        
                        this.$store.state.cadRequestRevisionContent.shio_request = true;
                        this.$store.state.cadRequestRevisionContent.SRS_request.shio_selection = '0';
                    }

                    else if(this.$store.state.hokkaidou.some(h => h.id === this.$store.state.cadRequestBasicInformation.house_type_id && (h.hokkaidou == '1') && this.$store.state.loggedInUser.isHokkaidou_planner == 1) && this.$store.state.cadRequestRevisionContent.SRS_request.shio_selection == '0'){
                        // this.$store.state.cadRequestRevisionContent.shio_request = true;
                        this.$store.state.cadRequestRevisionContent.SRS_request.shio_selection = '0';
                    }

                    // else if(this.$store.state.hokkaidou.includes(this.$store.state.cadRequestBasicInformation.house_type_id)){
                    else if(this.$store.state.hokkaidou.some(h => h.id === this.$store.state.cadRequestBasicInformation.house_type_id && (h.hokkaidou == '2' || h.hokkaidou == '1') && this.$store.state.loggedInUser.isHokkaidou_planner == 1) && this.$store.state.cadRequestRevisionContent.SRS_request.shio_selection == '1'){
                        // this.$store.state.cadRequestRevisionContent.shio_request = true;
                        this.$store.state.cadRequestRevisionContent.SRS_request.shio_selection = '1';
                    } 

                    else if(this.$store.state.hokkaidou.some(h => h.id === this.$store.state.cadRequestBasicInformation.house_type_id && (h.hokkaidou == '2' || h.hokkaidou == '1') && this.$store.state.loggedInUser.isHokkaidou_planner == 1) && this.$store.state.cadRequestRevisionContent.SRS_request.shio_selection == '3'){
                        this.$store.state.cadRequestRevisionContent.SRS_request.shio_selection = '3';
                    }
                } else {
                    // if(!this.$store.state.hokkaidou.includes(this.$store.state.cadRequestBasicInformation.house_type_id)){
                    
                    // NOTE  - CODED 20260623
                    // if(!this.$store.state.hokkaidou.some(h => h.id === this.$store.state.cadRequestBasicInformation.house_type_id && (h.hokkaidou == '2' || h.hokkaidou == '1'))){
                    
                    // NOTE  - CODED - 20260624
                    if(this.$store.state.loggedInUser.isHokkaidou_planner != 1 && this.$store.state.hokkaidou.some(h => h.id === this.$store.state.cadRequestBasicInformation.house_type_id && (h.hokkaidou != '2'))){
                        // this.$store.state.editCadRequestRevisionContent.SRS_request.shio_selection = '0';
                        if (!(this.$store.state.loggedInUser.can_use_srs == 1 && (this.$store.state.cadRequestBasicInformation.house_type_id == 35 || this.$store.state.cadRequestBasicInformation.house_type_id == 36 || this.$store.state.cadRequestBasicInformation.house_type_id == 38 || this.$store.state.cadRequestBasicInformation.house_type_id == 39))) {
                            this.$store.state.editCadRequestRevisionContent.shio_request = true;
                            this.$store.state.editCadRequestRevisionContent.SRS_request.shio_selection = '0';
                        } 
                    }else if (this.$store.state.loggedInUser.isHokkaidou_planner == 1 && !this.$store.state.hokkaidou.some(h => h.id === this.$store.state.cadRequestBasicInformation.house_type_id && (h.hokkaidou == '2' || h.hokkaidou == '1'))){
                        this.$store.state.editCadRequestRevisionContent.shio_request = true;
                        this.$store.state.editCadRequestRevisionContent.SRS_request.shio_selection = '0';
                    } else if(this.$store.state.hokkaidou.some(h => h.id === this.$store.state.cadRequestBasicInformation.house_type_id && (h.hokkaidou == '1') && this.$store.state.loggedInUser.isHokkaidou_planner == 1) && this.$store.state.editCadRequestRevisionContent.SRS_request.shio_selection == '0'){
                        this.$store.state.editCadRequestRevisionContent.SRS_request.shio_selection = '0';                        
                    }
                    // else if(this.$store.state.hokkaidou.includes(this.$store.state.cadRequestBasicInformation.house_type_id)){
                   else if(this.$store.state.hokkaidou.some(h => h.id === this.$store.state.cadRequestBasicInformation.house_type_id && (h.hokkaidou == '2' || h.hokkaidou == '1') && this.$store.state.loggedInUser.isHokkaidou_planner == 1) && this.$store.state.editCadRequestRevisionContent.SRS_request.shio_selection == '1'){
                        this.$store.state.editCadRequestRevisionContent.SRS_request.shio_selection = '1';
                    }

                    else if(this.$store.state.hokkaidou.some(h => h.id === this.$store.state.cadRequestBasicInformation.house_type_id && (h.hokkaidou == '2' || h.hokkaidou == '1') && this.$store.state.loggedInUser.isHokkaidou_planner == 1) && this.$store.state.editCadRequestRevisionContent.SRS_request.shio_selection == '3'){
                        this.$store.state.editCadRequestRevisionContent.SRS_request.shio_selection = '3';
                    }
                    
                }
            }
        },

        OPTION_11(val){
            if(val == '電気図面依頼') {
                if(!this.editMode){
                    // this.$store.state.cadRequestRevisionContent.shio_request = false;

                    // NOTE -  OLD CONDITION
                    // if (!this.$store.state.cadRequestRevisionContent.SRS_request) {
                    //     this.$store.state.cadRequestRevisionContent.SRS_request = {
                    //                                                                 shio_selection: null,
                    //                                                                 shio_number: null,
                    //                                                             };
                    // }
                    // this.$store.state.cadRequestRevisionContent.SRS_request.shio_selection = '0';

                    //NOTE - MODIFIED - 20260629
                    if(this.$store.state.loggedInUser.isHokkaidou_planner != 1 && this.$store.state.hokkaidou.some(h => h.id === this.$store.state.cadRequestBasicInformation.house_type_id && (h.hokkaidou != '2'))){
                        // this.$store.state.cadRequestRevisionContent.shio_request = true;
                        // this.$store.state.cadRequestRevisionContent.SRS_request.shio_selection = '0';
                        if (!(this.$store.state.loggedInUser.can_use_srs == 1 && (this.$store.state.cadRequestBasicInformation.house_type_id == 35 || this.$store.state.cadRequestBasicInformation.house_type_id == 36 || this.$store.state.cadRequestBasicInformation.house_type_id == 38 || this.$store.state.cadRequestBasicInformation.house_type_id == 39))) {
                            this.$store.state.editCadRequestRevisionContent.shio_request = true;
                            this.$store.state.cadRequestRevisionContent.SRS_request.shio_selection = '0';
                        } 
                        // console.log('hello');
                        
                    } else if (this.$store.state.loggedInUser.isHokkaidou_planner == 1 && !this.$store.state.hokkaidou.some(h => h.id === this.$store.state.cadRequestBasicInformation.house_type_id && (h.hokkaidou == '2' || h.hokkaidou == '1'))){
                        this.$store.state.cadRequestRevisionContent.shio_request = true;
                        this.$store.state.cadRequestRevisionContent.SRS_request.shio_selection = '0';                        
                    }

                    else if(this.$store.state.hokkaidou.some(h => h.id === this.$store.state.cadRequestBasicInformation.house_type_id && (h.hokkaidou == '1') && this.$store.state.loggedInUser.isHokkaidou_planner == 1) && this.$store.state.cadRequestRevisionContent.SRS_request.shio_selection == '0'){
                        // this.$store.state.cadRequestRevisionContent.shio_request = true;
                        this.$store.state.cadRequestRevisionContent.SRS_request.shio_selection = '0';                        
                    }

                    // else if(this.$store.state.hokkaidou.includes(this.$store.state.cadRequestBasicInformation.house_type_id)){
                    else if(this.$store.state.hokkaidou.some(h => h.id === this.$store.state.cadRequestBasicInformation.house_type_id && (h.hokkaidou == '2' || h.hokkaidou == '1') && this.$store.state.loggedInUser.isHokkaidou_planner == 1) && this.$store.state.cadRequestRevisionContent.SRS_request.shio_selection == '1'){
                        // this.$store.state.cadRequestRevisionContent.shio_request = true;
                        this.$store.state.cadRequestRevisionContent.SRS_request.shio_selection = '1';
                    }

                    else if(this.$store.state.hokkaidou.some(h => h.id === this.$store.state.cadRequestBasicInformation.house_type_id && (h.hokkaidou == '2' || h.hokkaidou == '1') && this.$store.state.loggedInUser.isHokkaidou_planner == 1) && this.$store.state.cadRequestRevisionContent.SRS_request.shio_selection == '3'){
                        this.$store.state.cadRequestRevisionContent.SRS_request.shio_selection = '3';
                    }
                } else {
                    // if(this.$store.state.getCadNashi){
                    //     this.$store.state.editCadRequestRevisionContent.shio_request = false;
                    // } else {
                    //     this.$store.state.editCadRequestRevisionContent.shio_request = true;
                    // }
                    // this.$store.state.editCadRequestRevisionContent.shio_request = true;

                    // NOTE - OLD CONDITION
                    // if (!this.$store.state.editCadRequestRevisionContent.SRS_request) {
                    //     this.$store.state.editCadRequestRevisionContent.SRS_request = {
                    //                                                                 shio_selection: null,
                    //                                                                 shio_number: null,
                    //                                                             };
                    // }
                    // this.$store.state.editCadRequestRevisionContent.SRS_request.shio_selection = '0';

                    // NOTE - MODIFIED 20260629
                    if(this.$store.state.loggedInUser.isHokkaidou_planner != 1 && this.$store.state.hokkaidou.some(h => h.id === this.$store.state.cadRequestBasicInformation.house_type_id && (h.hokkaidou != '2'))){
                        // this.$store.state.editCadRequestRevisionContent.shio_request = true;
                        // this.$store.state.editCadRequestRevisionContent.SRS_request.shio_selection = '0';

                        if (!(this.$store.state.loggedInUser.can_use_srs == 1 && (this.$store.state.cadRequestBasicInformation.house_type_id == 35 || this.$store.state.cadRequestBasicInformation.house_type_id == 36 || this.$store.state.cadRequestBasicInformation.house_type_id == 38 || this.$store.state.cadRequestBasicInformation.house_type_id == 39))) {
                            this.$store.state.editCadRequestRevisionContent.shio_request = true;
                            this.$store.state.editCadRequestRevisionContent.SRS_request.shio_selection = '0';
                        } 
                    }else if (this.$store.state.loggedInUser.isHokkaidou_planner == 1 && !this.$store.state.hokkaidou.some(h => h.id === this.$store.state.cadRequestBasicInformation.house_type_id && (h.hokkaidou == '2' || h.hokkaidou == '1'))){
                        this.$store.state.editCadRequestRevisionContent.shio_request = true;
                        this.$store.state.editCadRequestRevisionContent.SRS_request.shio_selection = '0';
                    } else if(this.$store.state.hokkaidou.some(h => h.id === this.$store.state.cadRequestBasicInformation.house_type_id && (h.hokkaidou == '1') && this.$store.state.loggedInUser.isHokkaidou_planner == 1) && this.$store.state.editCadRequestRevisionContent.SRS_request.shio_selection == '0'){
                        this.$store.state.editCadRequestRevisionContent.SRS_request.shio_selection = '0';
                    }
                    // else if(this.$store.state.hokkaidou.includes(this.$store.state.cadRequestBasicInformation.house_type_id)){
                   else if(this.$store.state.hokkaidou.some(h => h.id === this.$store.state.cadRequestBasicInformation.house_type_id && (h.hokkaidou == '2' || h.hokkaidou == '1') && this.$store.state.loggedInUser.isHokkaidou_planner == 1) && this.$store.state.editCadRequestRevisionContent.SRS_request.shio_selection == '1'){
                        this.$store.state.editCadRequestRevisionContent.SRS_request.shio_selection = '1';
                    }

                    else if(this.$store.state.hokkaidou.some(h => h.id === this.$store.state.cadRequestBasicInformation.house_type_id && (h.hokkaidou == '2' || h.hokkaidou == '1') && this.$store.state.loggedInUser.isHokkaidou_planner == 1) && this.$store.state.editCadRequestRevisionContent.SRS_request.shio_selection == '3'){
                        this.$store.state.editCadRequestRevisionContent.SRS_request.shio_selection = '3';
                    }
                }
            } 
        },

        // dialog(val){
        //     if(val.)
        // }

    }
}
</script>

<style>

</style>
